module.exports = __webpack_public_path__ + "static/media/i3.a1675dd1.png";